import { usePortalTranslation } from "../../i18n/portal.js";
/**
 * An order's status as the 2026-10-09 export draws it (design sync, Claude Design version 1791495439483263; the
 * prototype's `ST_STYLE` / `stStyleOf`): a rounded pill tinted per state instead of the tag — New in coral, In the
 * kitchen in process yellow, Out for delivery in the light accent, Delivered in the full accent, Cancelled as an
 * outline with the word struck through. "Ready" (a pickup order waiting at the counter) is a state the prototype does
 * not draw; it takes Out for delivery's tint, the step it stands in for. Shared by the Order screen and the order book.
 */
import type { ReactNode } from "react";

import { CUSTOMER_ORDER_STATUS_LABEL, type CustomerOrderStatusView } from "../agents/[id]/orders/order-book-gateway.js";

import "./order-status-pill.css";

export function OrderStatusPill(props: { readonly status: CustomerOrderStatusView }): ReactNode {
  usePortalTranslation("finance");
  return <span className={`ord-pill ord-pill-${props.status.replaceAll("_", "-")}`}>{CUSTOMER_ORDER_STATUS_LABEL[props.status]}</span>;
}
